import jsPDF from "jspdf";

// Utilidad para convertir número a letras (reutiliza la función del recibo)
import { numberToWordsEs } from "./generateReciboPDF";

// Carga el logo desde public y lo convierte a dataURL
async function loadLogoDataUrl() {
  return new Promise((resolve, reject) => {
    try {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = function () {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        if (!ctx) {
          resolve(null);
          return;
        }
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      };
      img.onerror = () => resolve(null);
      img.src = "/lux_logo.PNG"; // ubicado en public/lux_logo.PNG
    } catch (e) {
      resolve(null);
    }
  });
}

// Genera un PDF de reporte de calificaciones para un grupo

export async function generateReporteCalificacionesPDF({ grupo, estudiantes, descargar = false, lugar = null, fechaElaboracion = null }) {
  const doc = new jsPDF({ orientation: "landscape" });
  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 10;

  // Cargar logo solo una vez
  const logoDataUrl = await loadLogoDataUrl();
  const logoSize = 18;
  const headerTopY = 12;
  const centerX = pageWidth / 2;

  // Función para dibujar encabezado en cada página
  function drawHeader() {
    if (logoDataUrl) {
      doc.addImage(logoDataUrl, "PNG", margin, headerTopY - 6, logoSize, logoSize);
    }
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text("Centro De Estudios Superiores CMP, A.C.", centerX, 15, { align: "center" });
    doc.setFont("helvetica", "normal");
    doc.text("Ave. Venustiano Carranza Nte. 614", centerX, 20, { align: "center" });
    doc.text("CENTRO", centerX, 25, { align: "center" });
    doc.text("MONTERREY, MONTERREY, N.L. C.P.64000", centerX, 30, { align: "center" });
    doc.text("R.F.C CES9912132F4", centerX, 35, { align: "center" });
  }

  // Dibujar encabezado en la primera página
  drawHeader();


  // Datos del grupo
  const grupoY = 45;
  doc.setFontSize(9);
  doc.setFont("helvetica", "bold");
  doc.text(`Grupo: ${grupo?.codigo || grupo?.nombre || ""}`, margin, grupoY);
  doc.setFont("helvetica", "normal");
  // Mostrar materia justo después de grupo
  doc.text(`Materia: ${grupo?.materia || grupo?.materia_nombre || ""}`, margin, grupoY + 6);
  doc.text(`Turno: ${grupo?.turno || ""}`, margin, grupoY + 12);
  // Programa y campus alineados a la derecha
  doc.text(`Programa: ${grupo?.programa_academico || grupo?.programa || ""}`, pageWidth - margin, grupoY, { align: "right" });
  doc.text(`Ciclo: ${grupo?.ciclo || ""}`, margin, grupoY + 18);
  doc.text(`Asesor: ${grupo?.asesor_nombre || ""}`, margin, grupoY + 24);

  // Tabla de calificaciones (estructura igual a la del modal)
  const tableY = grupoY + 20;
  // Ampliar columna Estudiante y ajustar el resto
  const colX = [
    margin, // Estudiante
    margin + 85, // Matrícula (antes 90)
    margin + 125, // Parcial1 (antes 130)
    margin + 155, // Parcial2 (antes 160)
    margin + 185, // Parcial3 (antes 190)
    margin + 215, // Promedio (antes 220)
    margin + 245  // Observaciones (nuevo)
  ];
  const tableWidth = pageWidth - margin * 2;
  const headerHeight = 7;

  // Encabezados (única fila, fondo negro, texto blanco, solo parciales y promedio)
  doc.setFillColor(0, 0, 0);
  doc.rect(margin, tableY, tableWidth, headerHeight, "F");
  doc.setFontSize(9);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(255, 255, 255);
  doc.text("Estudiante", colX[0] + 2, tableY + 5);
  doc.text("Matrícula", colX[1] + 2, tableY + 5);
  doc.text("Parcial 1", colX[2] + 2, tableY + 5);
  doc.text("Parcial 2", colX[3] + 2, tableY + 5);
  doc.text("Parcial 3", colX[4] + 2, tableY + 5);
  doc.text("Promedio", colX[5] + 2, tableY + 5);
  doc.setFontSize(8);
  doc.text("Observaciones", colX[6] + 2, tableY + 5);

  // Filas de estudiantes
  doc.setFont("helvetica", "normal");
  doc.setFontSize(7);
  let currentY = tableY + headerHeight + 4;
  const rowSpacing = 7;
  // Mejor visibilidad: fuente más grande, color negro, espacio suficiente
  doc.setFontSize(10);
  doc.setTextColor(0, 0, 0);
  let startY = tableY + headerHeight + 10;
  let rowSpacingVisible = 10;
  // Lógica de redondeo especial para promedio
  const calcularFinal = (p1, p2, p3) => {
    if (p1 == null || p2 == null || p3 == null) return '';
    const total = (Number(p1) + Number(p2) + Number(p3)) / 3;
    if (total === 0) return 0;
    if (total < 6) return 5;
    if (total < 7) return 6;
    if (total < 7.5) return 7;
    if (total < 8.5) return 8;
    if (total < 9.5) return 9;
    return 10;
  };

  estudiantes.forEach((est, idx) => {
    const p1 = parseFloat(est.parcial1) || 0;
    const p2 = parseFloat(est.parcial2) || 0;
    const p3 = parseFloat(est.parcial3) || 0;
    const promedio = calcularFinal(p1, p2, p3);
    doc.text(est.nombre || est.nombre_completo || "", colX[0] + 2, startY);
    doc.text(est.matricula || "", colX[1] + 2, startY);
    doc.text(est.parcial1 !== undefined && est.parcial1 !== null ? String(est.parcial1) : "", colX[2] + 2, startY);
    doc.text(est.parcial2 !== undefined && est.parcial2 !== null ? String(est.parcial2) : "", colX[3] + 2, startY);
    doc.text(est.parcial3 !== undefined && est.parcial3 !== null ? String(est.parcial3) : "", colX[4] + 2, startY);
    doc.text(promedio !== '' ? String(promedio) : '', colX[5] + 2, startY);
    // Agregar observaciones con tamaño de fuente más pequeño
    doc.setFontSize(8);
    const observacionesText = est.observaciones || '';
    if (observacionesText) {
      // Limitar observaciones a 40 caracteres con elipsis si es más larga
      const observacionesTruncada = observacionesText.length > 40 
        ? observacionesText.substring(0, 40) + '...' 
        : observacionesText;
      doc.text(observacionesTruncada, colX[6] + 2, startY);
    }
    doc.setFontSize(10);
    startY += rowSpacingVisible;
    if (startY > 190) {
      doc.addPage();
      drawHeader();
      // Redibujar datos del grupo en cada página
      doc.setFontSize(9);
      doc.setFont("helvetica", "bold");
      doc.text(`Grupo: ${grupo?.codigo || grupo?.nombre || ""}`, margin, grupoY);
      doc.setFont("helvetica", "normal");
      doc.text(`Materia: ${grupo?.materia || grupo?.materia_nombre || ""}`, margin, grupoY + 6);
      doc.text(`Turno: ${grupo?.turno || ""}`, margin, grupoY + 12);
      doc.text(`Programa: ${grupo?.programa_academico || grupo?.programa || ""}`, pageWidth - margin, grupoY, { align: "right" });
      doc.text(`Ciclo: ${grupo?.ciclo || ""}`, margin, grupoY + 18);
      doc.text(`Asesor: ${grupo?.asesor_nombre || ""}`, margin, grupoY + 24);
      // Redibujar encabezados de tabla
      doc.setFillColor(0, 0, 0);
      doc.rect(margin, tableY, tableWidth, headerHeight, "F");
      doc.setFontSize(9);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(255, 255, 255);
      doc.text("Estudiante", colX[0] + 2, tableY + 5);
      doc.text("Matrícula", colX[1] + 2, tableY + 5);
      doc.text("Parcial 1", colX[2] + 2, tableY + 5);
      doc.text("Parcial 2", colX[3] + 2, tableY + 5);
      doc.text("Parcial 3", colX[4] + 2, tableY + 5);
      doc.text("Promedio", colX[5] + 2, tableY + 5);
      doc.setFontSize(8);
      doc.text("Observaciones", colX[6] + 2, tableY + 5);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);
      // Reiniciar startY justo debajo del encabezado de la tabla
      startY = tableY + headerHeight + 10;
    }
  });


  // Líneas para firmas al final
  let espacioFirmas = 40; // espacio vertical necesario para firmas
  let firmasY = startY + 30; // dejar un poco de espacio después del último registro
  const pageHeight = doc.internal.pageSize.getHeight();
  // Si no hay suficiente espacio, agregar nueva página y encabezado
  if (firmasY + espacioFirmas > pageHeight - margin) {
    doc.addPage();
    drawHeader();
    // Redibujar datos del grupo en la nueva página
    doc.setFontSize(9);
    doc.setFont("helvetica", "bold");
    doc.text(`Grupo: ${grupo?.codigo || grupo?.nombre || ""}`, margin, grupoY);
    doc.setFont("helvetica", "normal");
    doc.text(`Materia: ${grupo?.materia || grupo?.materia_nombre || ""}`, margin, grupoY + 6);
    doc.text(`Turno: ${grupo?.turno || ""}`, margin, grupoY + 12);
    doc.text(`Programa: ${grupo?.programa_academico || grupo?.programa || ""}`, pageWidth - margin, grupoY, { align: "right" });
    doc.text(`Ciclo: ${grupo?.ciclo || ""}`, margin, grupoY + 18);
    doc.text(`Asesor: ${grupo?.asesor_nombre || ""}`, margin, grupoY + 24);
    firmasY = grupoY + 50; // espacio debajo de los datos del grupo
  }
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  // Centramos las líneas y los textos de las firmas
  const firmaLineWidth = 100; // ancho de la línea de firma
  const espacioEntreFirmas = 60; // espacio entre las dos firmas
  const firma1X = centerX - firmaLineWidth - (espacioEntreFirmas / 2);
  const firma2X = centerX + (espacioEntreFirmas / 2);

  // Dibujar líneas centradas
  doc.line(firma1X, firmasY, firma1X + firmaLineWidth, firmasY);
  doc.line(firma2X, firmasY, firma2X + firmaLineWidth, firmasY);

  // Texto centrado debajo de cada línea
  doc.text("Director de Nivel", firma1X + firmaLineWidth / 2, firmasY + 10, { align: "center" });
  doc.text("Asesor Académico", firma2X + firmaLineWidth / 2, firmasY + 10, { align: "center" });

  // Descargar o devolver dataURL
  const dataUriString = doc.output("datauristring");
  if (descargar) {
    doc.save("reporte_calificaciones.pdf");
  }
  return dataUriString;
}
